import HTTPS_AXIOS from '@/config/http'
import baseURL from '@/config/index'

// 获取常见问题列表
export function getProblemInfo (datas) {
  const url = '/problemInfo/getProblemInfo'
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 修改问题点击数量
export function updateProblemClickNum (datas) {
  const url = '/problemInfo/updateProblemClickNum'
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 提交是否解决问题结果
export function submitProblemHelpRecord (datas) {
  const url = '/problemInfo/submitProblemHelpRecord'
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 用户登录  获取登录im的用户id与sig
export function addImUser (datas) {
  const url = `${baseURL.imUrl}/imInterface/imUserLogin`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取聊天记录
export function queryChatHistoryRecord (datas) {
  const url = `${baseURL.imUrl}/tencentCloudIM/queryChatHistoryRecord`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 提交客服评价
export function submitImEvaluationRecord (datas) {
  const url = `${baseURL.imUrl}/imInterface/submitImEvaluationRecord`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 消息撤回
export function messageRecall (datas) {
  const url = `${baseURL.imUrl}/tencentCloudIM/messageRecall`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 视频格式转换
export function movConversionMp4 (datas) {
  const url = `${baseURL.imUrl}/tencentCloudIM/movConversionMp4`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 提交留言
export function submitImNoteRecord (datas) {
  const url = `${baseURL.imUrl}/imInterface/submitImNoteRecord`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

export function imgUpload (datas) {
  const url = `${baseURL.imgUplpadUrl}`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取留言开关信息
export function queryImNoteSet (datas) {
  const url = `${baseURL.imUrl}/imInterface/queryImNoteSet`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 校验敏感图片
export function imgOrTextCheck (datas) {
  const url = `${baseURL.imUrl}/tencentCloudIM/imgOrTextCheck`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}

export function queryPlatformInfoById (datas) {
  const url = `${baseURL.imUrl}/imInterface/queryPlatformInfoById`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 向ai发送信息
export function sendChatMessages (datas, loadData, source) {
  let lastReceivedIndex = 0
  const url = `${baseURL.aiServer}/difyAI/sendChatMessages`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.get(url, {
      cancelToken: source.token,
      params: datas,
      responseType: 'stream',
      // 接收流式数据
      onDownloadProgress: (event) => {
        let resFullText = event.currentTarget.responseText
        // 获取新返回内容
        let newData = resFullText.substring(lastReceivedIndex)
        loadData(newData)
        lastReceivedIndex = resFullText.length
      }
    }
    ).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 查询会话是否被结束
export function queryIsUserEndSession (datas) {
  const url = `${baseURL.imUrl}/tencentCloudIM/queryIsUserEndSession`
  return new Promise((resolve, reject) => {
    HTTPS_AXIOS.post(url, datas).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js